import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';
import PageNavigation from '../../components/PageNavigation';
import { useTranslation } from 'react-i18next';

import { getPathList } from '../../common/data';

const Layout = () => {
  const { t } = useTranslation('common');
  const { isLogin } = useSelector(state => state.login);
  const { pathname } = useLocation();

  //헤더 데이터
  const pathList = getPathList(t);

  // 헤더 렌더링 함수
  const renderHeader = () => {
    const pathInfo = pathList[pathname];
    if (pathInfo && !pathname.includes('noHeader')) {
      return React.cloneElement(pathInfo.component, { title: pathInfo.title });
    }
    // return <SubHeader title="기본 제목" />;
  };

  // 아래쪽 이전, 다음 버튼 렌더링
  const renderPageNavigation = () => {
    const pathInfo = pathList[pathname];
    if (pathInfo && pathInfo.isPageNavigation) {
      return <PageNavigation prevPath={pathInfo.prevPath} nextPath={pathInfo.nextPath} />;
    }
  };

  const getMainLayoutPadding = pathname => {
    switch (pathname) {
      case '/':
        return '24px 16px 24px 16px';
      default:
        return '30px 16px';
    }
  };

  const mainLayout = {
    padding: getMainLayoutPadding(pathname),
    flex: 1,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  };

  return (
    <div
      className="displayFlexColumn"
      style={{ minHeight: '100vh'}}>
      {renderHeader()}
      <div style={mainLayout}>
        <Outlet />
      </div>
      {renderPageNavigation()}
    </div>
  );
};

export default Layout;
